import { createAction, props } from "@ngrx/store";
import { RoomAccountDeleteEventVO } from "@youm-front/room/domain";

export const roomAccountDeleteEvent = createAction(
  "[Room] Room Account Delete Event",
  props<{ roomAccountDeleteEventVO: RoomAccountDeleteEventVO }>()
);
